//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import arrayToTree from 'array-to-tree';
import SelectCouponModal from '../../coupons/components/select-coupon-modal';

export default {
    name: 'birthdayRuleEdit',
    components: { SelectCouponModal },
    data() {
        return {
            loading: false,
            saving: false,
            birthdaySetting: {
                id: 0,
                memberLevel: '',
                day: 1,
                isOnlyOwner: true,
                isOnlyOwnerStr: '是'
            },
            rules: {
                name: [{ required: true, message: '请输入规则名称', trigger: 'blur' }]
                // couponName: { required: true, message: '请选择优惠券', trigger: 'blur' },
                // presentType: [{ required: true, message: '请输入福利类型', trigger: 'change' }]
            },
            // birthdaySetting: {
            //
            // },
            checkAll: false,
            indeterminate: true,
            checkAllGroup: [],
            isEditRange: false,
            showTreeModal: false,
            cityRanges: [],
            projectTree: [],
            showSelectCouponModel: false
        };
    },
    methods: {
        getRule() {
            this.loading = true;
            abp.ajax.get('/api/services/app/Birthday/GetRuleById?id=' + this.ruleId).then(res => {
                this.birthdaySetting = {
                    id: 0,
                    memberLevel: '',
                    day: 1,
                    point: 0,
                    couponId: 0
                };
                this.cityRanges = [];
                this.checkAllGroup = [];
                this.isEditRange = false;
                this.$refs.birthdaySettingForm.resetFields();
                this.birthdaySetting = JSON.parse(JSON.stringify(res.data.result));
                this.cityRanges = this.birthdaySetting.cityRanges;
                this.pushType = this.birthdaySetting.pushType;
                if (this.birthdaySetting && this.birthdaySetting.memberLevel.length > 0) {
                    this.checkAllGroup = this.birthdaySetting.memberLevel.split(',');
                }
                if (this.birthdaySetting.id > 0) {
                    this.title = '编辑规则';
                } else {
                    this.title = '新增规则';
                }

            }).finally(() => {
                this.loading = false;
            });
        },
        endDateTimeChange(date) {
            this.birthdaySetting.endDateTime = date;
        },
        startDateTimeChange(date) {
            this.birthdaySetting.startDateTime = date;
        },
        onSave() {
            var vm = this;
            console.log(vm.birthdaySetting);
            // return;
            if (!this.birthdaySetting.startDateTime) {
                abp.message.warn('请输入有效开始时间');
                return;
            }
            if (!this.birthdaySetting.endDateTime) {
                abp.message.warn('请输入有效结束时间');
                return;
            }
            if (this.birthdaySetting.presentType == 0 && this.birthdaySetting.point <= 0) {
                abp.message.warn('请输入赠送积分');
                return;
            }
            if (this.birthdaySetting.presentType == 1 && this.birthdaySetting.couponId == 0) {
                abp.message.warn('请选择优惠券');
                return;
            }
            this.birthdaySetting.memberLevel = this.checkAllGroup.toString();

            if (this.isEditRange) {
                this.birthdaySetting.delCityRanges = this.birthdaySetting.cityRanges;
                this.birthdaySetting.cityRanges = vm.cityRanges;
            } else {
                this.birthdaySetting.delCityRanges = [];
            }
            this.birthdaySetting.isEditRange = this.isEditRange;
            var vm = this;
            this.$refs.birthdaySettingForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Birthday/SaveRule', this.birthdaySetting).then(res => {
                        // this.showBirthdaySettingEditModal = false;
                        // this.getPage();
                        vm.$router.push({
                            name: 'birthdaySettingInfo',
                            params: {
                                ruleId: res.data.result
                            }
                        });
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        }, showAddACoupon() {
            this.showSelectCouponModel = true;
        },
        addCoupon(data) {
            // console.log(data);
            this.birthdaySetting.couponName = data.name;
            this.birthdaySetting.couponId = data.id;
            this.showSelectCouponModel = false;
        },
        presentTypeChange(val) {
            if (val == '空') {

                this.birthdaySetting.couponId = 0;
                this.birthdaySetting.point = 0;

            } else if (val == 0 || val == '0') {
                this.birthdaySetting.couponName = '';
                this.birthdaySetting.couponId = 0;
            } else {
                this.birthdaySetting.point = 0;
            }
        },
        getProjectStagesTree() {
            abp.ajax.get('/api/services/app/Project/GetProjectStagesTree').then(res => {
                this.projectTree = [];
                this.projectTree = res.data.result.items;
                this.projectTree.forEach((item, index) => {
                    item.title = item.name;
                    item.children = item.projects;
                    item.type = 'city';
                    item.children.forEach(item => {
                        item.children = item.stages;
                        item.parentId = item.cityId;
                        item.type = 'project';
                        item.children.forEach(i => {
                            i.parentId = i.projectId;
                            i.type = 'fenqi';
                        });

                    });
                });

                this.projectTree = arrayToTree(this.projectTree, {
                    parentProperty: 'parentId',
                    customID: 'id'
                });
            }).finally(() => {
                // this.saving = false;
            });
        },
        onSelectTree() {
            var list = this.$refs.treeRef.getCheckedAndIndeterminateNodes();
            this.cityRanges = [];
            var select = list.filter(x => x.type === 'city');
            select.forEach(city => {
                this.cityRanges.push({
                    id: 0,
                    businessId: 0,
                    cityId: city.id,
                    businessType: 'Questionnaire',
                    cityName: city.title,
                    isAllCity: city.checked
                });
            });
            for (var i = 0; i < this.cityRanges.length; i++) {
                this.cityRanges[i].projectRanges = [];
                var s1 = list.filter(x => x.cityId === this.cityRanges[i].cityId);
                var sss = [];
                s1.forEach(project => {
                    sss.push({
                        id: 0,
                        cityRangeId: 0,
                        projectId: project.id,
                        projectName: project.title,
                        cityId: project.cityId,
                        isAllProject: project.checked
                        // projectId: item.projectId
                    });
                });

                this.cityRanges[i].projectRanges = sss;

                for (var j = 0; j < this.cityRanges[i].projectRanges.length; j++) {
                    this.cityRanges[i].projectRanges[j].stagesRanges = [];
                    var s2 = list.filter(x => x.projectId === this.cityRanges[i].projectRanges[j].projectId);

                    var ssss = [];
                    s2.forEach(s => {
                        ssss.push({
                            id: 0,
                            projectRangeId: 0,
                            name: s.title,
                            projectId: s.projectId
                        });
                    });
                    this.cityRanges[i].projectRanges[j].stagesRanges = ssss;
                }

            }
            this.showTreeModal = false;
            this.isEditRange = true;
        },
        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                // this.checkAllGroup = ['1', '2', '3', '4'];
                this.checkAllGroup = ['1', '2', '3', '4'];
            } else {
                this.checkAllGroup = [];
            }
        },
        checkAllGroupChange(data) {
            if (data.length === 4) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        isOnlyOwnerChange(val) {
            // console.log(val);
            if (val == '是') {
                this.birthdaySetting.isOnlyOwnerStr = '是';
                this.birthdaySetting.isOnlyOwner = true;
            } else {
                this.birthdaySetting.isOnlyOwnerStr = '否';
                this.birthdaySetting.isOnlyOwner = false;
            }
        }
    },
    created() {
        this.ruleId = parseInt(this.$route.params.ruleId) || 0;
        if (this.ruleId > 0) {
            this.getRule();
        }
        this.getProjectStagesTree();
    }
};
